<template>
  <div class="cart-num-components">
    <div class="opt-icon" @click="numChange('subtract', item)">
      <i class="iconfont icon-jian"></i>
    </div>
    <el-input
      v-model="item.quantity"
      type="number"
      :disabled="item.publishStatus == '0'"
      @input="inputChange(item)"
      @blur="inputBlur(item)"
      @focus="inputFocus(item)"
    ></el-input>
    <div class="opt-icon" @click="numChange('add', item)">
      <i class="iconfont icon-jia2"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "cart-num",
  props: {
    item: {
      type: Object,
      default: {},
    },
  },
  methods: {
    inputChange(item) {
      if (item.quantity != "" && item.quantity < 1) {
        item.quantity = 1;
      }
    },

    inputFocus(item) {
      item.historyQuantity = item.quantity;
    },

    inputBlur(item) {
      item.quantity = parseInt(item.quantity);
      item.minimumQuantity = parseInt(item.minimumQuantity);
      item.stock = parseInt(item.stock);
      item.packing = parseInt(item.packing);

      // 单次加购数
      let buyNum = item.packing;

      // 判断是否为可拆包装，X为不可拆，其它为可拆
      if (item.zzpsbczbz != "X") {
        buyNum = parseInt(item.singlePurchase);
      }

      // 判断输入的数量是否满足最小起购数量、大于库存数量
      if (!item.quantity || item.quantity == "") {
        if (item.historyQuantity) {
          item.quantity = item.historyQuantity;
        } else {
          this.$parent.getCartList();
        }

        return false;
      } else if (item.quantity % buyNum > 0) {
        // 输入完成后需根据最小包装数量倍数向上取整
        let num = item.quantity - (item.quantity % buyNum);

        // 判断加上最小包装后是否超过库存
        if (num + buyNum > item.stock) {
          item.quantity = num == 0 ? buyNum : num;
        } else {
          item.quantity = num + buyNum;
        }
      }

      // 判断最小采购数量
      if (item.quantity < item.minimumQuantity) {
        this.$message.warning("该商品最少" + item.minimumQuantity + "件起购！");
      }

      // 判断库存数量
      if (item.quantity > item.stock) {
        this.$message.warning("库存不足！");
      }

      if (item.quantity < item.minimumQuantity || item.quantity > item.stock) {
        if (item.historyQuantity) {
          item.quantity = item.historyQuantity;
        } else {
          this.$parent.getCartList();
        }

        return false;
      }

      // 失去焦点改变数量
      if (item.quantity != item.historyQuantity) {
        this.$parent.updateCartData("update", item);
      }
    },

    numChange(type, item) {
      if (this.$parent.lock) {
        return false;
      }
      let minus = null; // 是否校验库存
      item.quantity = parseInt(item.quantity);
      item.minimumQuantity = parseInt(item.minimumQuantity);
      item.stock = parseInt(item.stock);
      item.packing = parseInt(item.packing);

      // 单次加购数
      let buyNum = item.packing;

      // 判断是否为可拆包装，X为不可拆，其它为可拆
      if (item.zzpsbczbz != "X") {
        buyNum = parseInt(item.singlePurchase);
      }

      if (item.publishStatus == "0") {
        return false;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      if (type === "subtract") {
        if (item.quantity <= 1) {
          return false;
        }
        // 判断最小采购数量
        if (item.quantity - buyNum < item.minimumQuantity) {
          this.$message.warning(
            "该商品最少" + item.minimumQuantity + "件起购！"
          );
          return false;
        } else {
          // 计算数量
          item.quantity = item.quantity - buyNum;
        }
        minus = true;
      } else if (type === "add") {
        // 判断库存数量
        if (item.quantity + buyNum > item.stock) {
          this.$message.warning("库存不足！");
          return false;
        } else {
          let activityList = item.activityList.filter((e) => e.type == 7);
          if (
            activityList.length > 0 &&
            item.quantity + buyNum > activityList[0].perLimit
          ) {
            this.$message.warning("限购" + activityList[0].perLimit + "件");
            return false;
          }

          // 计算数量
          item.quantity = item.quantity + buyNum;
        }
      }

      // 更新后台数据
      this.timeoutId = setTimeout(() => {
        this.$parent.updateCartData("update", item, minus);
      }, 1000);
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss">
@import "@/assets/css/szui.scss";

.cart-num-components {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 28px;
  width: 124px;
  border: 1px solid #c0c4cc;
  border-radius: 5px;
  overflow: hidden;

  .opt-icon {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 28px;
    height: 100%;
    background: #f8f8f8;
    cursor: pointer;

    .iconfont {
      font-size: 13px;
      color: $fontColor;
    }
  }

  .el-input {
    .el-input__inner {
      padding: 0 9px;
      width: 66px;
      height: 28px;
      border-top: none;
      border-bottom: none;
      border-left: 1px solid #c0c4cc;
      border-right: 1px solid #c0c4cc;
      border-radius: 0;
      text-align: center;
      font-size: 16px;
    }
  }
}
</style>